// extracted by mini-css-extract-plugin
export default {"company-header":"Header_company-header__4dsBl","company-header-item":"Header_company-header-item__CMwAM"};